export default "__VITE_ASSET__BkUzFdt$__"